/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Filetoolarge4Inputs */

const en_coinvestments_dataroom_filetoolarge4 = /** @type {(inputs: Coinvestments_Dataroom_Filetoolarge4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File too large`)
};

/**
* | output |
* | --- |
* | "File too large" |
*
* @param {Coinvestments_Dataroom_Filetoolarge4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_filetoolarge4 = /** @type {((inputs?: Coinvestments_Dataroom_Filetoolarge4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Filetoolarge4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_filetoolarge4(inputs)
});
export { coinvestments_dataroom_filetoolarge4 as "coInvestments_dataRoom_fileTooLarge" }